import {TaskType} from '@toolify/client/src/stores/TaskStore/enum/TaskType'
import {ITaskTypeStrategy} from '@toolify/client/src/stores/TaskStore/strategies/ITaskTypeStrategy'
import {ITaskItem} from '@toolify/client/src/stores/TaskStore/types/ITaskItem'

export const DownloadTaskTypeStrategy: ITaskTypeStrategy<TaskType.Download> = {
  type: TaskType.Download,
  calculateTaskTime(task: ITaskItem<TaskType.Download>, otherTasks: ITaskItem[], params) {
    const speed = params.averageSpeedBytesPerSecond
    if (!speed || speed <= 0) {
      return null
    }

    const totalBytes = task.payload?.size || task.progress?.totalBytes
    if (!totalBytes || totalBytes <= 0) {
      return null
    }

    const transferredBytes = typeof task.progress?.bytesTransferred === 'number'
      ? task.progress.bytesTransferred
      : task.progress?.percentage
        ? totalBytes * task.progress.percentage
        : 0

    const remainingBytes = Math.max(0, totalBytes - transferredBytes)
    return remainingBytes / speed
  },
}
